import React, { FC, useEffect } from 'react'
import { isFulfilled } from '@reduxjs/toolkit'
import { push } from 'connected-react-router'



import { useDispatch, useSelector } from '../../store';
import { addCardThunk } from '../../store/billing/thunks'
import  CreditCard from '../../components/Billing/CreditCard';
import { TCardFormValues } from '../../models/form';

import { useToasts } from 'react-toast-notifications'
import { TOAST_MESSAGE } from '../../components/UI/ToastNotification/ToastNotification'
import './AddCard.scss'

interface AddCardProps { }

const AddCard: FC<AddCardProps> = (props) => {
    const dispatch = useDispatch()
    const { addToast } = useToasts()
    const {inProgress } = useSelector((state) => ({
        inProgress: state.billing.inProgress,
    }))

    const { error, card } = useSelector((state) => ({
       error: state.billing.error, 
       card: state.billing.card
    }))

    const saveCard = async (values:{data:TCardFormValues,state:any})=>{
        const { data , state:{touched}} = values;
        if(touched){
            const addCardResponse = await dispatch(addCardThunk(data))
            if (isFulfilled(addCardResponse)){
                addToast(TOAST_MESSAGE.CARD_ADDED, { appearance: 'success' })
                dispatch(push('/create-agency/1'))
            } 
        }else{
            dispatch(push('/create-agency/1'))
        }
    }

    return (
        <>
            <div className='onboarding-add-card'>
                <div className='onboarding-add-card-container'>
                    <div className='onboarding-add-card-container__form'>
                        <div className='onboarding-add-card-container__form__title'>Payment</div>
                        <div className="onboarding-add-card-container__form__text">Fill in your payment account details to start your<br />
                            <div className='onboarding-add-card-container__inline-link' >
                                14 day free trial
                            </div>
                        </div>
                        <CreditCard  cardDetails={card} inProgress={inProgress} error={error} saveCallBack={saveCard} showDescription={true} >
                        </CreditCard>
                    </div>

                </div>
            </div>

        </>
    )
}

export default AddCard
